import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import { loadTasApplicationHistory } from 'tio-data/requests/tas-application-actions';
import type { Store } from '@warp-drive/core';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';

export default class AuthenticatedTasApplicationsHistoryRoute extends Route {
  @service declare store: Store;

  includes = ['tas-courses', 'tas-program-instance.tas-program-template'];

  async model({
    tas_application_id,
  }: {
    tas_application_id: string;
  }): Promise<TasApplicationModel> {
    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', tas_application_id, {
        include: this.includes.join(','),
        reload: true,
      })
    )) as { content: { data: TasApplicationModel } };
    const application = content.data;
    await loadTasApplicationHistory(this.store, application);
    return application;
  }
}
